import React from 'react'
import AppLogo from 'app/components/AppLogo'
import { WebsiteLogoSection } from './styles'

const WebsiteLogo = () => {
	return (
		<WebsiteLogoSection>
			<AppLogo width={200} height={50} />
		</WebsiteLogoSection>
	)
}

export default React.memo(WebsiteLogo)
